module.exports = __webpack_public_path__ + "img/nav-patient_ORIGINAL.9268e99b.png";